import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { ProductiveAnimalDTO } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useGetProductiveAnimalList(animalId: string) {
  const { userFarm: farmId } = useAuth()

  return useQuery<ProductiveAnimalDTO[], Error>({
    queryKey: ['get-productive-animal-list', farmId, animalId],
    queryFn: () => animalController.getProductiveAnimalList(farmId!, animalId),
    enabled: !!farmId && !!animalId
  })
}
